import { Api } from '../../common/model';
import { Action as BookingAction } from '../actions/booking';
import { Action as SlotAction } from '../actions/slot';
import type { FormContent } from '../components/Form';
import type { State } from './index';

type Action = BookingAction | SlotAction;

export type BookingState = {
  departure: FormContent;
  arrival: FormContent;
  departureSlots?: Api.SiteSlots;
  arrivalSlots?: Api.SiteSlots;
  isFetchingDepartureSlots: boolean;
  isFetchingArrivalSlots: boolean;
  isArrivalSlotAvailable: boolean;
};

const initialState: BookingState = {
  departure: {},
  arrival: {},
  isArrivalSlotAvailable: false,
  isFetchingDepartureSlots: false,
  isFetchingArrivalSlots: false,
};

export default (state: BookingState = initialState, action: Action) => {
  switch (action.type) {
    case BookingAction.Type.DEPARTURE_CHANGED:
      return {
        ...state,
        departure: action.departure,
      };
    case SlotAction.Type.FETCH_DEPARTURE_SLOTS:
      return {
        ...state,
        isFetchingDepartureSlots: true,
      };
    case SlotAction.Type.CLEAR_DEPARTURE_SLOTS:
      return {
        ...state,
        isFetchingDepartureSlots: false,
        departureSlots: undefined,
      };
    case SlotAction.Type.FETCH_DEPARTURE_SLOTS_SUCCESS:
      return {
        ...state,
        departureSlots: action.slots,
        isFetchingDepartureSlots: false,
      };
    case BookingAction.Type.ARRIVAL_CHANGED:
      return {
        ...state,
        arrival: action.arrival,
      };
    case BookingAction.Type.DEPARTURE_CHECKPOINT_CHANGED:
      return {
        ...state,
        departure: { ...state.departure, checkpoint: action.checkpoint },
      };
    case BookingAction.Type.ARRIVAL_CHECKPOINT_CHANGED:
      return {
        ...state,
        arrival: { ...state.arrival, checkpoint: action.checkpoint },
      };
    case SlotAction.Type.FETCH_ARRIVAL_SLOTS:
      return {
        ...state,
        isFetchingArrivalSlots: true,
      };
    case SlotAction.Type.CLEAR_ARRIVAL_SLOTS:
      return {
        ...state,
        isFetchingArrivalSlots: false,
        arrivalSlots: undefined,
      };
    case SlotAction.Type.FETCH_ARRIVAL_SLOTS_SUCCESS:
      return {
        ...state,
        arrivalSlots: action.slots,
        isFetchingArrivalSlots: false,
      };
    case SlotAction.Type.ARRIVAL_SLOT_AVAILABLE:
      return {
        ...state,
        isArrivalSlotAvailable: true,
      };
    case SlotAction.Type.ARRIVAL_SLOT_UNAVAILABLE:
      return {
        ...state,
        isArrivalSlotAvailable: false,
      };
    default:
      return state;
  }
};

export const getBooking = (state: State) => state.booking;
